import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../apiClientContext";
import { fetchCurrentUser } from "./api";

const currentUserKey = ["identity", "me"] as const;

/**
 * The signed-in caller as the API sees them, including the Einstein.Admin
 * verdict. Identity is stable for the lifetime of a session, so this is cached
 * aggressively — admin status only changes across a fresh sign-in (which mints
 * a new token and remounts the app), never mid-session.
 */
export function useCurrentUser() {
    const client = useApiClient();
    return useQuery({
        queryKey: currentUserKey,
        queryFn: () => fetchCurrentUser(client),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    });
}
